import React, { useState, useEffect } from "react";
import RightSideStyleHolder from "../../../../../components/Styles/rightSideStyle";
import CardAverageCPMContainer from "../../../../../containers/CardAverageCPMContainer";
import CardAdsInfoContainer from "../../../../../containers/CardAdsInfoContainer";
import CardTotalSpotsContainer from "../../../../../containers/CardTotalSpotsContainer";
import CartBudgetContainer from "../../containers/sidebars/CartBudgetContainer";
import HiddenByCpmTypeContainer from "../../../../shared/containers/HiddenByCpmTypeContainer";
import { Button, Icon } from "antd";
import { useTranslation } from "react-i18next";
import { getDomain } from "../../../../../services/utils";


const RightSideComponent = ({
  stepsCurrent,
  programmatic,
  listResolutionWithContent,
  updateByAmountBudget,
  cart,
  customContents,
  updateRealAmount,
  editCampaignActive,
  editingCampaign,
  nextSteps,
  creationType,
  creatingCampaign,
  calculatingPrices,
  onFinish,
  isPaymentStatusApproved,
  payments,
  disabledNext
}) => {

  const { t } = useTranslation();
  const makingProposal = creationType === "makeProposal";
  const domain = getDomain(window.location.hostname);

  const [localSubmitting, setLocalSubmitting] = useState(false);

  useEffect(() => {
    if (!creatingCampaign && !editingCampaign) {
      setLocalSubmitting(false);
    }
  }, [creatingCampaign, editingCampaign]);

  const isFinishLoading = localSubmitting || creatingCampaign || editingCampaign;

  const handleFinish = () => {
    if (isFinishLoading) return;
    setLocalSubmitting(true);
    if (onFinish) onFinish();
  };

  const getFinishButtonText = () => {
    if (editCampaignActive) {
      return (!isPaymentStatusApproved && payments.length === 0) ? t("Save & Pay") : t("Save changes");
    }
    return makingProposal ? t("Create proposal") : t("Confirm & Pay");
  };

  return (
    <RightSideStyleHolder>
      <div className="rightSideContainer">
        {
          stepsCurrent === 2
          &&
          <Button
            className={`continueButtons createButton ${domain === 'dv360' ? 'dv360' : ''}`}
            loading={isFinishLoading}
            disabled={isFinishLoading}
            onClick={handleFinish}
          >
            <span style={{ textTransform: "capitalize" }}>
              {getFinishButtonText()}
            </span>
            <Icon className="createIcon" type={makingProposal ? "check" : "arrow-right"} />
          </Button>
        }
        {
          stepsCurrent < 2
          &&
          <Button
            className={`continueButtons ${domain === 'dv360' ? 'dv360' : ''}`}
            onClick={nextSteps}
            disabled={disabledNext}
            loading={calculatingPrices}
          >
            <span style={{ textTransform: "capitalize" }}>
              {t("Continue")}
            </span>
            <Icon className="createIcon" type="arrow-right" />
          </Button>
        }
        <div className="rightSideCards">
          {
            stepsCurrent === 0
            &&
            <>
              {programmatic === "programmatic" && (
                <CardAverageCPMContainer stepsCurrent={stepsCurrent} />
              )}
              <CardAdsInfoContainer
                listResolutionWithContent={listResolutionWithContent}
              />
            </>
          }
          {
            stepsCurrent === 1 && programmatic === "programmatic"
            &&
            <>
              <CartBudgetContainer
                stepsCurrent={stepsCurrent}
                updateByAmountBudget={updateByAmountBudget}
                cart={cart}
                customContents={customContents}
                updateRealAmount={updateRealAmount}
              />
              {programmatic === "programmatic" && (
                <CardAverageCPMContainer stepsCurrent={stepsCurrent} />
              )}
            </>
          }
          {
            stepsCurrent === 1 && programmatic === "programmatic"
            &&
            <HiddenByCpmTypeContainer>
              <CardTotalSpotsContainer
                  stepsCurrent={stepsCurrent}
                  customContents={customContents}
                />
            </HiddenByCpmTypeContainer>
        }
        </div>
      </div>
    </RightSideStyleHolder>
  );
};

export default RightSideComponent;
